<template>
    <div class="noticia-page">
        <title-header :title="'UGT-SP Notícias'"/>
        <div class="content">
            <main>
                <news :text="main_article.noticia"
                      :title="main_article.titulo"
                      :img="main_article.imagens"
                      :subtitle="main_article.subtitulo"
                      :date="main_article.data_noticia">
                </news>
                <news-aside :id="$route.params.id"></news-aside>
            </main>
            <latest-news :id="$route.params.id"></latest-news>
        </div>
    </div>
</template>

<script>
import titleHeader from '../../../../components/title/title.vue'
import newsHeader from './components/news-header.vue'
import newsAside from './components/news-aside.vue'
import latestNews from './components/latest-news.vue'
import news from './components/news.vue'
import axios from 'axios'

export default {
    name: "page-noticias",
    components: {
        titleHeader,
        newsHeader,
        newsAside,
        latestNews,
        news
    },
    data() {
        return {
            main_article: {},
        }
    },
    methods: {
        getMainArticle(id){
            axios.get('get-noticia-atual/'+id)
                .then(res => {
                    this.main_article = res.data.noticia
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    created() {
        this.getMainArticle(this.$route.params.id)
    }
};
</script>

<style lang="scss" scoped>
.noticia-page {
    @apply p-16 pt-0;
    @media (max-width: 1024px) {
        @apply p-4;
    }

    .content {
        main {
            @apply w-full flex justify-center;
            @media (max-width: 768px) {
                @apply flex-col;
            }
        }
    }
}
</style>
